import { pick } from '#layers/base/utils/pick'

export default defineNuxtRouteMiddleware(async (to) => {
  const { isLoggedIn, user, forceRefresh } = useAgsUser()

  // Ported from ags-storefront/middleware/authGuard.global.ts:
  // SSR-only forceRefresh (mad-storefront upstream pattern) leaves client-side
  // navigation with stale user state, so a guest who just submitted
  // /signin?redirectUrl=/de/checkout never propagates the logged-in flag to the
  // authGuard fired on /de/checkout. Run forceRefresh whenever user state is
  // missing on either side; try/catch keeps a transient API blip from
  // breaking navigation.
  if (!user.value && forceRefresh) {
    try {
      await forceRefresh()
    } catch (error) {
      console.error('Failed to refresh user in authGuard:', error)
    }
  }

  const localePath = (routePath: LinkList[keyof LinkList]['path']) => {
    const getLocalePath = useLocalePath()
    return getLocalePath(routePath) || routePath
  }

  const getProtectedRoutes = (exclude: (keyof LinkList)[] = []) => {
    const routes = Object.entries(
      pick(routeList, ['account', 'orders', 'orderDetail', 'checkout', 'user']),
    ).reduce((routeMap, [name, value]) => {
      if (exclude.some((routeName) => routeName === name)) {
        return routeMap
      }

      Object.assign(routeMap, { [name]: value })
      return routeMap
    }, {} as Partial<LinkList>)

    return Object.values(routes).map((it) => localePath(it.path))
  }

  const isGuest = !!user.value?.status?.isGuestCustomer

  const isProtectedRoute = getProtectedRoutes().some((path) => to.path === path)
  const isProtectRouteForGuest =
    isGuest && getProtectedRoutes(['checkout']).some((path) => to.path === path)

  if (!isLoggedIn.value && isProtectedRoute) {
    return navigateTo({
      path: localePath(routeList.signin.path),
      query: {
        redirectUrl: to.fullPath,
      },
    })
  }
  if (isLoggedIn.value && isProtectRouteForGuest) {
    const redirectPath = (to.query.redirectUrl as string) || routeList.home.path
    return navigateTo({ path: redirectPath })
  }
})
